import React, { useState } from "react";

function DelayPrediction() {
  const [manpower, setManpower] = useState("");
  const [weatherRain, setWeatherRain] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPrediction = async () => {
    setLoading(true);
    try {
      // 보내는 데이터 예시 (진행률(progress), 계획기간(planned_duration)은 서버에서 고정)
      const inputData = {
        manpower: Number(manpower),
        weather_rain: Number(weatherRain),
      };

      const response = await fetch("http://localhost:8000/prediction/delay/", {
        method: "POST", // POST로 바꾸고
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(inputData), // JSON 형태로 보냄
      });

      if (!response.ok) {
        throw new Error("네트워크 응답 에러");
      }
      const data = await response.json();
      setResult(data.predicted_duration);
    } catch (error) {
      console.error("API 호출 실패:", error);
      setResult("오류 발생");
    }
    setLoading(false);
  };

  return (
    <div>
      <label>
        투입 인원:
        <input
          type="number"
          value={manpower}
          onChange={(e) => setManpower(e.target.value)}
          min="0"
        />
      </label>
      <br />
      <label>
        비 오는 정도 (0~2):
        <input
          type="number"
          value={weatherRain}
          onChange={(e) => setWeatherRain(e.target.value)}
          min="0"
          max="2"
        />
      </label>
      <br />
      <button onClick={fetchPrediction}>지연 예측하기</button>
      <div>진행률 60%, 계획기간 150일</div>
      {loading && <p>로딩 중...</p>}
      {result !== null && !loading && <p>예측 공사 기간: {result} 일</p>}
    </div>
  );
}

export default DelayPrediction;
